<template>
  <div style="height: 100%; width: 100%">
    <div class="race_nav">
      <span @click="checkSteps(1)" :class="{ active: steps == 1 }"
        >项目基础信息</span
      >
      <span @click="checkSteps(2)" :class="{ active: steps == 2 }"
        >项目概况</span
      >
      <span @click="checkSteps(3)" :class="{ active: steps == 3 }"
        >项目实施过程</span
      >
      <span @click="checkSteps(4)" :class="{ active: steps == 4 }"
        >项目成效与反思</span
      >
    </div>
    <div class="race_body">
      <RaceDetail v-if="steps == 1"></RaceDetail>
      <RaceOverview v-if="steps == 2"></RaceOverview>
      <ProjectProcess v-if="steps == 3"></ProjectProcess>
      <ProjectEffect v-if="steps == 4"></ProjectEffect>
    </div>
    <div class="race_btn">
      <el-button type="primary" @click="goTo('/eventCenter?userid=' + userid + '&oid=' + oid)">赛事信息</el-button>
      <el-button type="primary" @click="lastSteps" v-if="steps != 1"
        >上一步</el-button
      >
      <el-button type="primary" @click="nextSteps" v-if="steps != 4"
        >下一步</el-button
      >
    </div>
  </div>
</template>

<script>
import RaceDetail from "./addRace/raceDetail.vue";
import RaceOverview from "./addRace/raceOverview.vue";
import ProjectProcess from "./addRace/projectProcess.vue";
import ProjectEffect from "./addRace/projectEffect.vue";
export default {
  components: {
    RaceDetail,
    RaceOverview,
    ProjectProcess,
    ProjectEffect,
  },
  data() {
    return {
      steps: 1,
      userid: this.$route.query.userid,
      oid: this.$route.query.oid,
    };
  },
  methods: {
    checkSteps(steps) {
      this.steps = steps;
    },
    nextSteps() {
      this.steps++;
    },
    lastSteps() {
      this.steps--;
    },
    goTo(path) {
      this.$router.push(path);
    },
  },
};
</script>

<style scoped>
.race_nav {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin: 10px 0;
}

.race_nav span {
  border: 1px solid #929292;
  border-radius: 5px;
  padding: 10px 15px;
  cursor: pointer;
  color: #4988bf;
}

.race_nav span + span {
  margin-left: 10px;
}

.race_nav .active {
  color: #001fff;
}

.race_body {
  display: flex;
  width: 90%;
  justify-content: center;
  margin: 0 auto;
  height: calc(100% - 120px);
}

.race_btn {
  width: 90%;
  margin: 10px auto 0;
  display: flex;
  justify-content: flex-end;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/race/addRace.vue